import { defineWidgetCore } from "../../widgetDefinition";
import type { TitleComponentSpec } from "../../Processing/types";
import { renderTitle } from "../../PDF/renderers/titlePdfRenderer";
import { resolveTemplate } from "../../Utils/resolveTemplate";

export const titleCore = defineWidgetCore<TitleComponentSpec>({
  process(spec) {
    return { type: "title", spec };
  },
  pdf: {
    buildSnapshot({ processed, slicerValues }) {
      if (processed.type !== "title") return null;
      const rawTitle = processed.spec.display.title ?? "Untitled";
      const { resolved } = resolveTemplate(rawTitle, slicerValues);
      return { type: "title", title: resolved };
    },
    render({ snapshot, rect, scale }) {
      if (snapshot.type !== "title") return null;
      return renderTitle(snapshot, rect, scale);
    },
  },
});
